import './textblock.scss'

import {ImageType, TextBlockType} from 'campagne/types'

import {Block} from '../blocks'
import {Picture} from '@codeurs/front'
import React from 'react'
import {Theme} from 'views/campagne/theme'
import {WysiwygType} from '../../../../types'
import {style} from 'util/style'

const styles = style('textblock')

const TextBlock: React.FC<TextBlockType> = ({text, image, text_tooltips}) => {
	const addTooltips = (input: WysiwygType) => {
		return input.replace(/{{(.+?)::(.+?)}}/g, (match, key, value) => {
			const found = text_tooltips.find((t) => t.tooltip_key === key)
			let tipText = !found ? '' : found.tooltip_text
			tipText = tipText
				.replace('<strong>', '<b>')
				.replace('</strong>', '</b>')
				.replace(/\n/g, '::NEWLINE::')
			tipText = tipText.replace(/<[^\/abi\s]+?[^>]*>|<\/[^abi]>/g, '')
			tipText = tipText.replace('::NEWLINE::', '<br/>')
			const tip = `<span class="${styles('tooltip-data')}">${tipText}</span>`
			return `<span class="${styles('tooltip')}">${value}${tip}</span>`
		})
	}

	const tooltipText = addTooltips(text)

	if (image && image.length === 0)
		return (
			<Block className={styles()}>
				<Theme.Wysiwyg>{tooltipText}</Theme.Wysiwyg>
			</Block>
		)

	return (
		<Block className={styles()}>
			<div className={styles('cols')}>
				<div className={styles('cols-col').mod('text')}>
					<Theme.Wysiwyg>{tooltipText}</Theme.Wysiwyg>
				</div>
				<div className={styles('cols-col').mod('images')}>
					{image &&
						image.map(
							(image: ImageType, index) =>
								image.src && (
									<div key={index} className={styles('cols-col-image')}>
										<Picture
											src={image.src}
											width={image.width}
											height={image.height}
											focus={image.focus}
											alt={image.alt}
										/>
										{image.alt && (
											<div className={styles('cols-col-image-label')}>
												{image.alt}
											</div>
										)}
									</div>
								)
						)}
				</div>
			</div>
		</Block>
	)
}

export default TextBlock
